import { IChangeListItemWashTypeProps } from "./ChangeListItemTypes"

import { Text, Flex, Center, Image } from "@chakra-ui/react"

const ChangeListItemWashType: React.FC<IChangeListItemWashTypeProps> = ({ title, value }) => {

  const imgUrl = value.split("\r")[0]
  const carType = value.split("\r")[1]
  const price = Number(value.split("\r")[2])
  const time = value.split("\r")[3]

  return (
    <>
      <Text mb={"8px"} fontSize="base">
          {title}
      </Text>
      <Flex padding={"16px"} borderRadius={"10px"} align={"center"} justifyContent="center" bgColor={"#fff"}>
          <Center w="50px" h="50px" bg="input_border_color_primary" borderRadius="base">
            <Image src={imgUrl} w="34px"/>
          </Center>
          <Text ml="15px" mr="20px" fontSize="base">{carType}</Text>
          <Center
            w="80px"
            h="50px"
            borderRadius="base"
            border="2px solid"
            borderColor="input_border_color_primary"
            fontSize="xl"
            mr="16px"
          >
            {price} <strong>₾</strong>
          </Center>
          <Center
            w="80px"
            h="50px"
            borderRadius="base"
            border="2px solid"
            borderColor="input_border_color_primary"
            fontSize="xl"
          >
            {time} <sub><strong>წთ</strong></sub>
          </Center>
      </Flex>
    </>
  )
}

export default ChangeListItemWashType